import { requestUser } from "../../apis";

export const apiRequestSignUp = (params: any): any =>
  requestUser("post", `/api/register`, params, false);

export const apiSendMail = (): any =>
  requestUser("post", `/api/mail/send`, null, true);

export const apiVerifyMail = (params: any): any =>
  requestUser("post", `/api/mail/verify `, params, true);
